/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2023.
 */

import {
	GA4_EVENT_PASSWORD_RECOVERY_BEGIN,
	PAGE_DATA_LAYER,
	PASSWORD_RECOVERY_BEGIN,
} from '@/data/constants/gtm';
import { getGTMPasswordRecoveryBeginEventData } from '@/data/events/data/gtm/PasswordRecoveryBegin';
import { getGTMConfig } from '@/data/events/handlers/gtm';
import { GTMPasswordRecoveryBeginPayload } from '@/data/types/GTM';
import { error as logError } from '@/data/utils/loggerUtil';
import TagManager from 'react-gtm-module';

export const measure_GA4 = async (
	data: ReturnType<typeof getGTMPasswordRecoveryBeginEventData>
) => {
	const dataLayerName = PAGE_DATA_LAYER;
	TagManager.dataLayer({
		dataLayer: { event: GA4_EVENT_PASSWORD_RECOVERY_BEGIN, ...data },
		dataLayerName,
	});
};

export const measure_UA = async (data: ReturnType<typeof getGTMPasswordRecoveryBeginEventData>) => {
	const dataLayerName = PAGE_DATA_LAYER;
	TagManager.dataLayer({
		dataLayer: { event: PASSWORD_RECOVERY_BEGIN, ...data },
		dataLayerName,
	});
};

export const sendGTMPasswordRecoveryBeginEvent = async (
	payload: GTMPasswordRecoveryBeginPayload
) => {
	const { ga4, ua } = getGTMConfig(payload.settings);

	if (ua || ga4) {
		const data = getGTMPasswordRecoveryBeginEventData(payload);
		if (ua) {
			try {
				await measure_UA(data);
			} catch (error) {
				logError(
					undefined,
					'PasswordRecoveryBegin: sendGTMPasswordRecoveryBeginEvent: measure_UA: error: %o',
					error
				);
			}
		}

		if (ga4) {
			try {
				await measure_GA4(data);
			} catch (error) {
				logError(
					undefined,
					'PasswordRecoveryBegin: sendGTMPasswordRecoveryBeginEvent: measure_GA4: error: %o',
					error
				);
			}
		}
	}
};
